import * as types from './types';

import { execApi, execApiWithParam } from '../api/apiActions';
import { openSuccessDialog } from '../dialog/dialogActions';
import MedicationApi from '../../apis/medications';

export const getMedications = () => {
  return dispatch => {
    dispatch(execApi({
        type: types.GET_MEDS,
        api: MedicationApi.getMedications,
        successCallback: response => {
          dispatch({
            type: types.GET_MEDS,
            payload: response.medications,
          })
        },
        useErrorDialog: true,
      })
    );
  };
};

export const requestRefill = (data) => {
  return dispatch => {
    dispatch(execApiWithParam({
        type: types.REQUEST_MED_REFILL,
        api: MedicationApi.requestRefill,
        param: data,
        successCallback: () => {
          dispatch(openSuccessDialog({
            content: 'Your medication request has been sent for review'
          }));
        },
        useErrorDialog: true,
      })
    );
  };
};


// WEBPACK FOOTER //
// ./src/actions/medication/medicationActions.js